import {Component, signal, WritableSignal} from '@angular/core';
import {
  CalendarDays,
  LucideAngularModule,
  Search,
  Star,
  Clock,
  UserRoundPlus
} from 'lucide-angular';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-how-it-works',
  imports: [
    LucideAngularModule,
    TranslatePipe
  ],
  templateUrl: './how-it-works.html',
})
export class HowItWorks {
  activeTab: WritableSignal<'client' | 'hairdresser'> = signal('client');

  toggleActiveTab(selectedTab: 'client' | 'hairdresser'): void {
    this.activeTab.set(selectedTab);
  }

  protected readonly Search = Search;
  protected readonly Star = Star;
  protected readonly CalendarDays = CalendarDays;
  protected readonly Clock = Clock;
  protected readonly UserRoundPlus = UserRoundPlus;
}
